import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { CLIENT_CONFIG } from '@config/config';
import { internalRoutes } from '@config/config.base';
import { navigationRoutes } from '@config/links.base';
import { Observable } from 'rxjs';
import { GeotabEulaService } from 'src/app/iframe-authentication/services/geotab-eula/geotab-eula.service';

@Injectable({
  providedIn: 'root',
})
export class GeotabAuthGuard implements CanActivate {
  constructor(
    private accessService: AccessService,
    private router: Router,
    private dataService: DataService,
    private geotabEulaService: GeotabEulaService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
    // state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    const isLoggedIn = this.accessService.hasValidToken();
    if (!isLoggedIn) {
      this.router.navigate(['geotab-login'], { replaceUrl: true });
      return false;
    }
    const isAllowed = CLIENT_CONFIG.allowedRoutes.concat(internalRoutes).includes(route.url[0].path);
    const isAccessible = isAllowed && this.isRouteAccessible(route.url[0].path);
    if (!(isAllowed && isAccessible)) {
      this.router.navigate(['page-not-accessible']);
      return false;
    }
    return this.eula();
  }

  private eula(): Promise<boolean> {
    return new Promise((resolve) => {
      this.geotabEulaService.isEULAAccepted().subscribe((value) => {
        if (value) {
          resolve(true);
        } else {
          this.router.navigate(['geotab-eula'], { replaceUrl: true });
        }
      });
    });
  }

  private isRouteAccessible(path: string) {
    const userInfo = this.accessService.getLoginInfo();
    const currentFleetId = this.dataService._currentFleet.value;
    const currentFleetInfo = (userInfo?.fleets || []).find((f) => f.fleetId === currentFleetId);

    const isInternalRoute = internalRoutes.includes(path);
    const currentPathConfig = navigationRoutes[path];
    const isAccessible =
      isInternalRoute || !currentPathConfig.uiConfigKey || currentFleetInfo.role.uiPermissions.includes(currentPathConfig.uiConfigKey);
    return isAccessible;
  }
}
